import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  ParticipantByDay,
  ParticipantsByDayRequest,
  ParticipantsByDayResponse,
  WinnerInfo,
} from './types'
import { isAllElementsOfSearchTextNotExist } from '../../../../libs/utils'
import { $params } from '../../../../features/router'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'client.clientId') {
        return [`client.id`, item[1]?.toLowerCase()]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

export const participantsByDayMounted = createEvent<ParticipantsByDayRequest>()

export const getParticipantsByDay = fx<
  ParticipantsByDayRequest,
  ParticipantsByDayResponse
>({
  method: 'GET',
  url: `/promo/ramadan/participant_by_day`,
})

export const $participantsByDay = restore<ParticipantByDay[]>(
  getParticipantsByDay.doneData.map((a) => a.body.items),
  [],
)

export const $participantsByDayStatistic = restore<{
  ruffleWinner: WinnerInfo | null
  traderWinner: WinnerInfo | null
  winningTicket: string | null
}>(
  getParticipantsByDay.doneData.map((a) => ({
    ruffleWinner: a.body.ruffleWinner,
    traderWinner: a.body.traderWinner,
    winningTicket: a.body.winningTicket,
  })),
  {
    ruffleWinner: null,
    traderWinner: null,
    winningTicket: null,
  },
)

export const $totalCountOfParticipantsByDay = restore(
  getParticipantsByDay.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: participantsByDayMounted,
  source: $params,
  fn: (
    params,
    { limit, page, orderBy, orderDirection, searchText, filters },
  ) => {
    let id
    if (params) {
      id = params.competitionID
    }

    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy.includes('country')) {
      orderBy = 'client.country'
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      newObj['day'] = id

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    // @ts-ignore
    query['populate'] =
      '["RamadanParticipantStat.client","Client.id","Client.fullName","Client.email","Client.country","RamadanParticipantStat.lots","RamadanParticipantStat.tickets","RamadanParticipantStat.day"]'

    return {
      query,
    }
  },
  target: getParticipantsByDay,
})
